import { render } from "./NoProjectsAlert.vue?vue&type=template&id=0ec80d0b"
import script from "./NoProjectsAlert.vue?vue&type=script&lang=js"
export * from "./NoProjectsAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__